/**
 * Result renderer dispatch. Keyed on ResultCard.tool.
 * Spec: v2-design/RESULT_RENDERING_v0_spec.md §1.
 */
import React from 'react';

import { ChartVizResult } from './ChartVizResult';
import { DriverAnalysisResult } from './DriverAnalysisResult';
import { EditScenariosChartResult } from './EditScenariosChartResult';
import { UnknownResultFallback } from './UnknownResultFallback';

export function pickResultRenderer(
  content: Record<string, unknown>
): React.ReactElement {
  const tool = String(content.tool ?? '');
  const chartPayload = content.chart_payload as
    | Record<string, unknown>
    | undefined;

  if (tool === 'chart_visualization' && chartPayload) {
    return <ChartVizResult chartPayload={chartPayload as never} />;
  }
  if (tool === 'driver_analysis' && chartPayload) {
    return <DriverAnalysisResult data={chartPayload} />;
  }
  if (tool === 'edit_scenarios' && chartPayload) {
    return <EditScenariosChartResult chartPayload={chartPayload} />;
  }
  return <UnknownResultFallback content={content} />;
}
